module.exports = __webpack_public_path__ + "img/yoyo.a6b33b6e.svg";